// extracted by mini-css-extract-plugin
module.exports = {"afterIcon":"DateInput_afterIcon__1Eu-A","dateInput":"DateInput_dateInput__1SKUD","focused":"DateInput_focused__-OLsw"};